<div class="popup-container">
    <button mat-button mat-dialog-close (click)="closeDialog()" class="close black-button">X</button>

    <h2 class="p-3 mb-0 roboto-medium">Close Route</h2>
    <hr id="shadow">
    <br>
    <div>
        <p class="paragraph">Do you want to set the status of the route {{routeName}} as arrived ?</p>
        <div class="upload d-flex">
            <label class="catlabel col-3 star-icon" for="input3">Unload Date:</label>
            <input class="category col-9" [(ngModel)]="unloadDate"  type="date" />
          </div>
          <div class="upload d-flex">
            <label class="catlabel col-3 " for="input4">Unload Time:</label>
            <div class="category col-9">
              <ngx-timepicker-field  class="form-control timepicker" [format]="24"
                [defaultTime]="'00:00'" [(ngModel)]="unloadTime"></ngx-timepicker-field>
            </div>
    </div>
    <div class="right-align">
        <button (click)="close()" class="cancel me-3 ms-3 roboto-bold"> CANCEL </button>
        <button (click)="closeStatus()" class="deletebutt roboto-medium"> OK </button>
        <!-- (click)="closeStatus()" -->
    </div>


</div>
